import { useQuery, ApolloQueryResult } from '@apollo/client';

import { GetDutchiePosLoyaltyConfigDocument } from 'src/gql/graphql';
import type { GetDutchiePosLoyaltyConfigQuery } from 'src/gql/graphql';

type UseGetDutchiePosLoyaltyConfigProps = {
  dispensaryId?: string;
  enterpriseId?: string;
  isoRegionCode?: string;
  skip?: boolean;
};

type UseGetDutchiePosLoyaltyConfigReturn = {
  data: GetDutchiePosLoyaltyConfigQuery['getDutchiePosLoyaltyConfig'] | undefined;
  loading: boolean;
  refetch: () => Promise<ApolloQueryResult<GetDutchiePosLoyaltyConfigQuery>>;
};

export const useGetDutchiePosLoyaltyConfig = ({
  dispensaryId,
  enterpriseId,
  isoRegionCode,
  skip = false,
}: UseGetDutchiePosLoyaltyConfigProps): UseGetDutchiePosLoyaltyConfigReturn => {
  const skipQuery = skip || (!dispensaryId && !enterpriseId);

  const { data, loading, refetch } = useQuery(GetDutchiePosLoyaltyConfigDocument, {
    variables: {
      dispensaryId,
      enterpriseId,
      isoRegionCode,
    },
    fetchPolicy: 'network-only',
    skip: skipQuery,
  });

  return {
    data: data?.getDutchiePosLoyaltyConfig,
    loading,
    refetch,
  };
};
